import { isEmpty } from "lodash";
import reduxStore from "../../../configureEnvStore";

import { ERROR_TYPE, MEDIA_PERMISSIONS } from "../../../constants/CallSettingConstants";
import { AUDIO_STATUS, DEVICE_TYPES, ENABLED, WAITING_CLOCK_ICON } from "../../../constants/Constants";
import { CALL_DATA, GLOBAL_MEETING_DATA, PublicVariables } from "../../../constants/PublicVariables";

import {
    setAllAudioTrackIdentity,
    setAudioError,
    setAudioErrorModal,
    setShowiOSAudioMsg,
    setShowPopupForPlayAudio,
    setStartLocalAudio,
} from "../../../reducers/twilioEvents-reducer";
import { LogFirebase } from "../../../services/firestore";
import { getRoom, setLocalAudioTrack } from "../Room/roomService";

import { getUserDetailsById, handleAudioFirebaseAndGoogleEvent, handleErrorForAudio } from "../Room/roomFunction";
import { createMyLocalAudioTrack, getTracksByType, setTrackName } from "../twilioCallUtility";
import { setIsAudioButtonClickDisable } from "../../../reducers/common-reducer";
import { loadDetectRTC } from "../../../shared/function";
import { isAgentIdentity, isSafariBelow16, isSilentObserver, singleUserEnabled } from "../../../shared/utility";
import { setAudioPermission } from "../../../reducers/call-setting-reducer";
import { micCameraPermissionDatatrackSend, sendRequestToAgentStartAudioOrVideo } from "../../../shared/dataTrackFunction";
import { removeAudioNotificationModal } from "../../ParticipantsList/HostControlledParticipants/HostControlledParticipantUtils";
import CustomToast from "../../UI/customToast";
import Localize from "../../../locale/Localize";
import { FIREBASE_EVENT_CATEGORY } from "../../../constants/FirebaseConstants";

export const getAudioParams = () => {
    const audioParam = { name: setTrackName("audio") };
    const { currentAudioDevice } = reduxStore.getState().callSetting;
    if (!isEmpty(currentAudioDevice?.deviceId)) {
        //from change audio input
        const room = getRoom();
        const localAudioTracks = getTracksByType(room.localParticipant, "audio");
        if (localAudioTracks.length > 0 && localAudioTracks[0].name.indexOf("a") > -1) {
            audioParam.name = audioParam.name.toUpperCase(); // NOTE: to fix duplicate track name issue.A_12345
        } else {
            audioParam.name = audioParam.name.toLowerCase(); //a_12345
        }
        audioParam.deviceId = { exact: currentAudioDevice?.deviceId }; // NOTE: on ios safari - it respects the deviceId only if its exact.
    }
    console.log("audio_input: ", audioParam);
    return audioParam;
};

export const manageNewLocalAudiotracks = (fromUnmute) => {
    if (checkIsAudioPermissionBlock()) {
        return;
    }
    const audioParam = getAudioParams();
    createMyLocalAudioTrack(audioParam).then(
        function (audioTrack) {
            const room = getRoom();
            room.localParticipant.publishTrack(audioTrack);
            setLocalAudioTrack(audioTrack);
            LogFirebase("Audio", "audio_track_created", { identity: CALL_DATA.localIdentity, room_Name: room.name });
            if (PublicVariables.featureFlag.SHOWMEMICROPHONE == "1" || fromUnmute) {
                handleEnableDisableAudio(true, audioTrack, false); // going to enable audio
            } else {
                handleEnableDisableAudio(false, audioTrack, true); // going to disable audio
            }
            reduxStore.dispatch(setAudioPermission(MEDIA_PERMISSIONS.GRANTED));
            micCameraPermissionDatatrackSend("mic");
        },
        function (error) {
            console.log(error);
            LogFirebase("Audio", "audio_track_creation_failed", { error: error });
            handleErrorForAudio();
        }
    );
};

export const handleToggleAudio = () => {
    LogFirebase("Micinfo", "mute_called", "");
    const room = getRoom();
    const localAudioTracks = getTracksByType(room?.localParticipant, "audio");
    const { startLocalAudio } = reduxStore.getState().twilioEvents;

    if (startLocalAudio) {
        LogFirebase("Micinfo", "mute_audio", "");
        reduxStore.dispatch(setIsAudioButtonClickDisable(false)); // enable audio button(button click variable)
        localAudioTracks.forEach(function (audioTrack) {
            handleEnableDisableAudio(false, audioTrack, startLocalAudio); // going to disable audio
        });
        return;
    }

    if (!startLocalAudio && localAudioTracks.length == 0) {
        // audio track going to create
        // audio track doesnt exist
        manageNewLocalAudiotracks(true);
        return;
    }

    if (!startLocalAudio && localAudioTracks.length != 0) {
        // audio going to enable
        loadDetectRTC().then((result) => {
            if (result.hasMicrophone && result.isWebsiteHasMicrophonePermissions) {
                localAudioTracks.forEach(function (audioTrack) {
                    handleEnableDisableAudio(true, audioTrack, startLocalAudio);
                });
                return;
            } else {
                handleErrorForAudio();
                reduxStore.dispatch(setStartLocalAudio(false));
            }
        });
    }
};

export const handleRemoveEnabledAudioTrackIdenity = (updateIdentity) => {
    const currentAudioTracksIdentity = reduxStore.getState().twilioEvents.allAudioTrackIdentity;

    // Find the index of the item to remove
    const indexToRemove = currentAudioTracksIdentity.findIndex((identity) => identity.identity === updateIdentity);
    const isAgent = isAgentIdentity(updateIdentity);

    if (indexToRemove !== -1 && !isAgent) {
        // Ensure the identity exists before removing
        const updatedAudioTracksIdentity = [
            ...currentAudioTracksIdentity.slice(0, indexToRemove),
            ...currentAudioTracksIdentity.slice(indexToRemove + 1),
        ];

        // Dispatch the updated list to Redux
        reduxStore.dispatch(setAllAudioTrackIdentity(updatedAudioTracksIdentity));
    }
};

export const handleAllEnabledAudioTrackIdenity = (updateIdentity) => {
    const currentEnabledAudioTracks = reduxStore.getState().twilioEvents.allAudioTrackIdentity;

    // Check if identity already exists
    const identityExists = currentEnabledAudioTracks.some((track) => track.identity === updateIdentity);

    const isAgent = isAgentIdentity(updateIdentity);
    if (!identityExists && !isAgent) {
        const newIdentity = { identity: updateIdentity };
        const updatedEnabledAudioTracksIdentity = [...currentEnabledAudioTracks, newIdentity];

        reduxStore.dispatch(setAllAudioTrackIdentity(updatedEnabledAudioTracksIdentity));
    }
};

export const handleEnableDisableAudio = (isFromEnable, audioTrack, startLocalAudio) => {
    removeAudioNotificationModal();
    if (isFromEnable) {
        audioTrack.enable();
        handleAudioFirebaseAndGoogleEvent(CALL_DATA.localIdentity, startLocalAudio);
        handleAllEnabledAudioTrackIdenity(CALL_DATA.localIdentity);
        return;
    }
    if (!isFromEnable) {
        reduxStore.dispatch(setIsAudioButtonClickDisable(false)); // enable audio button(button click variable)
        audioTrack.disable();
        handleAudioFirebaseAndGoogleEvent(CALL_DATA.localIdentity, startLocalAudio);
        reduxStore.dispatch(setStartLocalAudio(false));
        handleRemoveEnabledAudioTrackIdenity(CALL_DATA.localIdentity);
        return;
    }
};

export const checkiOSUserAudio = function () {
    //for safari users only
    if (GLOBAL_MEETING_DATA.device_type == DEVICE_TYPES.IOS_BROWSER && isSafariBelow16()) {
        CALL_DATA.localAudioMsg = true;
        reduxStore.dispatch(setShowiOSAudioMsg(true));
        closeiOSSpeakerMsg();
    }
};

export const showSpeakerMsgForiOSGuest = function (identity) {
    let user = getUserDetailsById(identity);
    //show message only for iOS browser users.

    if (user?.device_type == DEVICE_TYPES.IOS_BROWSER && user?.appVersion <= 16) {
        CALL_DATA.localAudioMsg = false;
        CALL_DATA.remoteAudioMsg = true;
        reduxStore.dispatch(setShowiOSAudioMsg(true));
        CALL_DATA.gblAudioAgentMsgShown = true;
        closeiOSSpeakerMsg();
    }
};

let iOSToastTimer = null;
/* shown for ios user or agent with remote ios user */
export const closeiOSSpeakerMsg = function (forced) {
    if (forced) {
        clearTimeout(iOSToastTimer);
        reduxStore.dispatch(setShowiOSAudioMsg(false));
    } else {
        /**hide the ios speaker issue msg info popup after 7seconds */
        iOSToastTimer = setTimeout(() => {
            const { isRemoteParticipantJoined } = reduxStore.getState().commonReducer;
            if (isRemoteParticipantJoined) {
                //so that fadeout effect can be seen
                clearTimeout(iOSToastTimer);
                reduxStore.dispatch(setShowiOSAudioMsg(false));
            }
        }, 15000);
    }
};

export const checkIsAudioPermissionBlock = () => {
    const { audioPermission } = reduxStore.getState().callSetting;
    if (audioPermission == MEDIA_PERMISSIONS.BLOCKED) {
        reduxStore.dispatch(setAudioError(ERROR_TYPE.PERMISSION));
        reduxStore.dispatch(setAudioErrorModal(true));
        LogFirebase("Audio", "Audio_track_creation_failed", { audioPermission: MEDIA_PERMISSIONS.BLOCKED });
        return true;
    }
    return false;
};

export const micButtonLDFlagStatus = (ldMicButtonStatus) => {
    const { isAgent, isGuest } = GLOBAL_MEETING_DATA;
    const { isObserver } = CALL_DATA;

    return !(
        (
            (ldMicButtonStatus == AUDIO_STATUS.DISABLE_FOR_AGENT_ONLY && (isAgent || isObserver)) || // Disable for Agent only (including silent observer)
            (ldMicButtonStatus == AUDIO_STATUS.DISABLE_FOR_GUEST_ONLY && isGuest) || // Disable for Guests only
            ldMicButtonStatus == AUDIO_STATUS.DISABLE_FOR_AGENT_AND_GUEST_BOTH
        ) // Disable for Agent and Guests both
    );
};

export const micButtonLDFlagStatusForHostControl = (identity, ldMicButtonStatus) => {
    const isAgent = isAgentIdentity(identity);
    const isObserver = isSilentObserver(identity);
    const isGuest = !isAgent && !isObserver;

    return !(
        (
            (ldMicButtonStatus == AUDIO_STATUS.DISABLE_FOR_AGENT_ONLY && isObserver) || // Disable for silent observer
            (ldMicButtonStatus == AUDIO_STATUS.DISABLE_FOR_GUEST_ONLY && isGuest) || // Disable for Guests only
            ldMicButtonStatus == AUDIO_STATUS.DISABLE_FOR_AGENT_AND_GUEST_BOTH
        ) // Disable for Agent and Guests both
    );
};

const playIfAudioIsPaused = () => {
    /* Get all audio elements within the element with ID 'audioTag' */
    const audioElements = document.getElementById("audioTag")?.querySelectorAll("audio") || [];

    // Iterate over all audio elements
    audioElements?.forEach((audioEle) => {
        if (audioEle.paused) {
            const showPopupForPlayAudio = reduxStore.getState().twilioEvents?.showPopupForPlayAudio;
            if (!showPopupForPlayAudio) {
                // setAudioActionText()
                reduxStore.dispatch(setShowPopupForPlayAudio(true));
                LogFirebase("Remote Audio", "audio_paused", "true");
            }
        } else {
            console.error("Audio is in play condition"); // do nothing
        }
    });
};

export const remoteParticipantAudioChecker = (() => {
    let intervalId = null; // Private variable scoped inside the closure

    const start = () => {
        if (intervalId) {
            // Clear existing interval if one is running
            clearInterval(intervalId);
        }
        intervalId = setInterval(() => {
            // Start a new interval
            const room = getRoom();
            if (room?.participants) {
                room.participants?.forEach((remoteParticipant) => {
                    const trackArr = getTracksByType(remoteParticipant, "audio");
                    if (trackArr?.length > 0 && trackArr[0]?.isEnabled) {
                        playIfAudioIsPaused();
                    }
                });
            }
        }, 15000);
    };

    const stop = () => {
        if (intervalId) {
            // Clear the interval if it's running
            clearInterval(intervalId);
            intervalId = null; // Reset the interval ID
        }
    };

    return { start, stop };
})();

export const audioTracksExist = () => {
    const room = getRoom();
    let audioTracksExist = false;
    let trackArr = null;
    room?.participants?.forEach(function (remoteParticipant, val) {
        if (!isSilentObserver(remoteParticipant.identity)) {
            trackArr = getTracksByType(remoteParticipant, "audio");
            if (trackArr && trackArr.length > 0 && trackArr[0].isEnabled) {
                audioTracksExist = true;
            }
        }
    });
    return audioTracksExist;
};

/* checks weather local or remote audio is available or not */
export const isAudioAvailable = (audioType) => {
    const { startLocalAudio } = reduxStore.getState().twilioEvents;
    let audioAvailable = false;
    if (audioType == "any") {
        if (audioTracksExist() || startLocalAudio) {
            audioAvailable = true;
        }
    }
    return audioAvailable;
};

export const requestMicPermissionToTheAgent = () => {
    const { joinMeetingData } = reduxStore.getState().joinMeeting;
    const { startLocalAudio } = reduxStore.getState().twilioEvents;
    const { audioPermission } = reduxStore.getState().callSetting;

    if (
        !GLOBAL_MEETING_DATA.isAgent &&
        joinMeetingData?.sessionConfigurations?.ASKMICPERMISSION == ENABLED &&
        audioPermission !== MEDIA_PERMISSIONS.BLOCKED &&
        !startLocalAudio &&
        !singleUserEnabled()
    ) {
        const localizedValues = Localize[PublicVariables.currentLanguageObj.languageCode];
        const waitingToastText = localizedValues?.microphone_request_sent + " " + localizedValues?.waiting_for_host_approval;
        const participantName = CALL_DATA.participantUserName;
        sendRequestToAgentStartAudioOrVideo("1", participantName); // 1 mic, 2 Camera
        const uniqueKey = `${CALL_DATA.localIdentity}1`; // 1 mic, 2 Camera
        CustomToast.info(waitingToastText, 10000, true, WAITING_CLOCK_ICON, {
            toastId: uniqueKey,
        });
        LogFirebase(FIREBASE_EVENT_CATEGORY.REQUEST_MIC_CAMERA, "send_mic_request_permission_to_the_agent", true);
        return true;
    }
    return false;
};
